export enum RefundOfferFormField {
  RefundOffer = 'refund_offer',
}

export type RefundOfferFormModel = {
  [RefundOfferFormField.RefundOffer]: string
}
